import { IDeThiInProgressRequest } from "../../../model/request/de-thi/de-thi-in/IDeThiInProgressRequest";
import { ISMT_DeThiIn_Request } from "../../../model/request/de-thi/de-thi-in/ISMT_DeThiIn_Request";
import { ISMT_DeThiIn } from "../../../model/respone/de-thi/ISMT_DeThiIn";
import { apiClient } from "../../apiClient";

export const DE_THI_IN_ENDPOINT = "de-thi-in";
export const deThiInApi = {
  Select: (payload: ISMT_DeThiIn) => apiClient.get(`${DE_THI_IN_ENDPOINT}`),
  SelectByRequest: (payload: ISMT_DeThiIn_Request) =>
    apiClient.get(
      `${DE_THI_IN_ENDPOINT}/select-vm/he/${payload.id_he}/mon/${payload.id_mon}/nhom/${payload.id_nhomdethiin}/chu-de/${payload.id_chude_dethiin}`
    ),
  SelectById: (id: number) => apiClient.get(`${DE_THI_IN_ENDPOINT}/${id}`),
  Insert: (payload: FormData) =>
    apiClient.post(`${DE_THI_IN_ENDPOINT}`, payload),
  Update: (payload: FormData) =>
    apiClient.put(`${DE_THI_IN_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${DE_THI_IN_ENDPOINT}/${id}`),
  ChangeUse: (id: number) =>
    apiClient.get(`${DE_THI_IN_ENDPOINT}/change-use/${id}`),
  DeleteMultiple: (ids: number[]) =>
    apiClient.put(`${DE_THI_IN_ENDPOINT}/delete-multiple`, ids),
  Progress: (payload: IDeThiInProgressRequest) =>
    apiClient.post(`${DE_THI_IN_ENDPOINT}/progress`, payload),
};
